import { useEffect } from 'react'

import { DEFAULT_DOCUMENT_TITLE } from 'src/default/config'

const useDocumentTitle = (title: string | undefined) => {
  const defaultTitle = DEFAULT_DOCUMENT_TITLE

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.title = title ? `${title} | ${defaultTitle}` : defaultTitle
    }

    return () => {
      if (typeof document !== 'undefined') {
        document.title = defaultTitle
      }
    }
  }, [title])
}

export default useDocumentTitle
